import SectionTitle from '../../sectionTitle/SectionTitle';
import styles from './ourServices.module.css';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';


export default function OurServices() {

  const navigateTo = useNavigate();

  return (
    <section className='bgAliceBlue'>
      <div className={`${styles.container} container-lg px-2`}>

        <div className={styles.images_container}>
          <motion.div className={styles.bigImage_wrapper}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{/*once: true,*/ amount: 0.2 }}
            transition={{ duration: 1, ease: 'easeOut' }}
          >
            <img src="/assets/images/services/service1.jpg" alt="services" loading="lazy" />
          </motion.div>
          <motion.div className={styles.smallImage_wrapper}
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{/*once: true,*/ amount: 0.2 }}
            transition={{ duration: 1, ease: 'easeOut' }}
          >
            <img src="/assets/images/services/service2.jpg" alt="services" loading='lazy' />
          </motion.div>
        </div>

        <motion.div className={`${styles.content} text-muted align-items-center align-items-sm-start`}
          initial={{ y: 150, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1, ease: 'easeOut' }}
        >

          <SectionTitle title='خدمات ما' titleClassName='position-relative me-sm-3 me-lg-0' />

          <p>برخی از خدمات شرکت نوآوران پژوه:</p>

          <ul className='lh-lg me-3 mt-4'>
            <li style={{ listStyleType: 'disc' }}>واردات مستقیم تجهیزات و مواد شیمیایی آلی و معدنی از برندهای معتبر با تضمین کیفیت و قیمت رقابتی</li>
            <li style={{ listStyleType: 'disc' }}>ارائه مشاوره فنی و تخصصی به مشتریان گرامی جهت انتخاب بهترین محصولات متناسب با نیازهایشان</li>
            <li style={{ listStyleType: 'disc' }}>توزیع گسترده محصولات در صنایع مختلف از جمله داروسازی، کشاورزی، پتروشیمی، رنگ‌سازی و ...</li>
            <li style={{ listStyleType: 'disc' }}>تجهیز آزمایشگاه ها و مراکز تحقیقاتی</li>
            <li style={{ listStyleType: 'disc' }}>نصب تجهیزات و خدمات پس از فروش</li>
            <li style={{ listStyleType: 'disc' }}>و بسیاری خدمات متنوع دیگر ...</li>
          </ul>

          <div className='d-flex justify-content-center mt-3 mt-lg-5 align-self-center w-100'>
            <Button className={styles.moreBTN} variant='primary' onClick={() => navigateTo('/contactUs')}>ثبت درخواست</Button>
          </div>

        </motion.div>

      </div>
    </section>
  )
}
